module.exports = __webpack_public_path__ + "img/Flag_of_Portugal.8399d871.svg";